import React from 'react';

import { SearchToggle } from '../../SearchToggle';

interface IRequirementItemProps {
  value: boolean;
  label: string;
  onChange: (isSelected: boolean) => void;
  icon: React.ReactNode;
}

const RequirementItem: React.FC<IRequirementItemProps> = ({ value, onChange, label, icon }) => {
  return (
    <span className="flex items-center justify-start mb-4 text">
      <div className="flex items-center ml-auto">{icon}</div>
      <SearchToggle
        ariaLabel={label}
        className="w-full"
        content={{ label }}
        contentOnLeft
        onChange={onChange}
        isSelected={value}
      />
    </span>
  );
};

export default RequirementItem;
